/**
 * Sorting field tags alphabetically. Couldn't figure out how to do this in
 * Views or Twig in a reasonable time, so doing it here with jQuery...
 *
 * Take into account views and node fields...
 */
(function ($, Drupal, once) {
  Drupal.behaviors.fieldTagsSort = {
    attach: function (context, settings) {
      once(
        "fieldTagsSort",
        ".views-field-field-tags .item-list, .field--name-field-tags",
        context
      ).forEach(function (element) {
        const $items = $(element).find("> ul > *, > .field__items > *");
        $items.sort(function (a, b) {
          let keyA = $(a).text();
          let keyB = $(b).text();

          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        });
        $.each($items, function (i, li) {
          $(element)
            .find("> ul ,> .field__items")
            .append(li); /* This removes li from the old spot and moves it */
        });
      });
    },
  };
})(jQuery, Drupal, once);
